import { Action, Reducer } from "redux";
import { SupervisorTypes, SupervisorState, SupervisorActionTypes } from "./supervisorTypes";
import { haskeyReducer } from "@/main/services/reducerUtils";

export const INITIAL_STATE: SupervisorState = {
	supervisors: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	domain: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const supervisorReducer: Reducer<SupervisorState> = (state: SupervisorState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as SupervisorActionTypes;

	switch (actionTypes.type) {
		case SupervisorTypes.GET_SUPERVISOR: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) {
				return {
					...state,
					isolated: {
						...state.isolated,
						[actionTypes.payload.keyReducer]: {
							...(state.isolated[actionTypes.payload.keyReducer] ?? INITIAL_STATE.supervisors),
							isLoading: true,
						},
					},
					supervisors: {
						...state.supervisors,
						isLoading: true,
					},
				};
			}

			return {
				...state,
				supervisors: { ...state.supervisors, isLoading: true },
			};
		}

		case SupervisorTypes.GET_SUPERVISOR_DOMAIN:
			return {
				...state,
				domain: { ...state.domain, isLoading: true },
			};

		case SupervisorTypes.SAVE_SUPERVISOR_DOMAIN:
			return {
				...state,
				domain: {
					...state.domain,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};

		case SupervisorTypes.SAVE_SUPERVISOR: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) {
				return {
					...state,
					isolated: {
						...state.isolated,
						[actionTypes.payload.keyReducer]: {
							...state.isolated[actionTypes.payload.keyReducer],
							isLoading: false,
							errorMessages: actionTypes.payload.errorMessages,
							isError: actionTypes.payload.isError,
							data: actionTypes.payload.data,
						},
					},
				};
			}
			return {
				...state,
				supervisors: {
					...state.supervisors,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}

		case SupervisorTypes.RESET_REDUCER_SUPERVISOR:
			return {
				...state,
				supervisors: INITIAL_STATE.supervisors,
				domain: INITIAL_STATE.domain,
			};

		default:
			return state;
	}
};

export default supervisorReducer;
